import { useApiGet } from '../../api/Api.hooks';

export interface StudyParticipantNotes {
  id: number;
  subject: string;
  note: string;
  created: Date;
  intendedStartDate: Date;
}

export function useGetStudyParticipantNotes(studyParticipantId: number) {
  const { data, isLoading, error, get } = useApiGet<StudyParticipantNotes[]>(
    `study-participants/${studyParticipantId}/notes`
  );
  return {
    studyParticipantNotes: data,
    loadingStudyParticipantNotes: isLoading,
    loadingStudyParticipantNotesError: error,
    getStudyParticipantNotes: get
  };
}
